export default "__VITE_ASSET__CW9vc48f__"